import Cookie from 'js-cookie';
import { Dispatch } from 'redux';
import { getDomain } from 'tldts';
import { EmbeddedChatController } from '../controllers/EmbeddedChatController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';

const EmbeddedChatActions = {
  getConfiguration: (facebookPageId?: number) => {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        return await EmbeddedChatController.getConfiguration(facebookPageId);
      } catch (error) {
        commonHandler(dispatch)(error);
      }
    };
  },

  authorize: (facebookPageId?: number, llrDomain?: string) => {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        return await EmbeddedChatController.authorize(
          facebookPageId,
          llrDomain,
        );
      } catch (error) {
        commonHandler(dispatch)(error);
      }
    };
  },

  clearStorage: () => {
    return async () => {
      try {
        const domain = getDomain(window.location.href);

        const removeCookieAndLocalStorage = (name: string) => {
          localStorage.removeItem(name);
          if (domain) {
            Cookie.remove(name, {
              path: '/',
              domain,
            });
          }
        };
        removeCookieAndLocalStorage('MobileMonkeyWebchatPersona');
        removeCookieAndLocalStorage('MobileMonkeyWindowActive');
        removeCookieAndLocalStorage('MobileMonkeyWebchatSenderID');
        sessionStorage.removeItem('MobileMonkeyGreetingClosed');
      } catch {}
    };
  },
};

export const useEmbeddedChatActions = getActionHookBuilder(
  EmbeddedChatActions,
  ['authorize', 'clearStorage', 'getConfiguration'],
);
